module.exports = __webpack_public_path__ + "img/noData_icon.1af558dd.png";